import { GetInitials } from "Helpers/Format";

import * as S from "./styles";

const ProjectTitle = ({ open }) => {
  const name = "Sevenx Incentivo";

  return (
    <S.Wrapper open={open}>
      <S.AvatarBorder>
        <S.AvatarInitials>{GetInitials(name || "B F")}</S.AvatarInitials>
      </S.AvatarBorder>

      <S.Campaign open={open}>
        <S.CampaignTitle>{name}</S.CampaignTitle>
        <S.CampaignText></S.CampaignText>
      </S.Campaign>
    </S.Wrapper>
  );
};

export default ProjectTitle;
